// extracted by mini-css-extract-plugin
export default {"section":"page_section__laQUv","title":"page_title__fhaD7"};